import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import axios from "axios";

const FeaturedBlogs = () => {
    const { selectedLanguage, langJson } = useLanguage();
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchFeaturedBlogs();
    }, []);

    const fetchFeaturedBlogs = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}blogs/featured`);
            setBlogs(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching featured blogs:", error);
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <div className="fullContainer">
                <h1>{langJson?.featuredBlogs || "Featured Blogs"}</h1>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <div className="blogs-list">
                        {blogs.map((blog) => (
                            <div key={blog.id} className="blog-item">
                                <h2>
                                    <Link to={`/blogs/${blog.slug}`}>{blog.title}</Link>
                                </h2>
                                <p>{blog.excerpt}</p>
                                <small>{blog.created_at}</small>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default FeaturedBlogs;